/*----------------------------------
- TOOLS MEGA MENU
----------------------------------*/

import { LANDING_TOOLS_MENU_GROUPS } from '@/client/catalogs/landing/toolsMenu';
import MegaMenuPanel from './MegaMenuPanel';
import MenuGroupColumns from './MenuGroupColumns';
import type { MenuNavigateHandler } from './navClick';

/*----------------------------------
- TYPES
----------------------------------*/

type ToolsMegaMenuProps = {
    id: string;
    isOpen: boolean;
    onNavigate: MenuNavigateHandler;
};

/*----------------------------------
- COMPONENT
----------------------------------*/

/**
 * The standalone tools, the ones a visitor can open without a workflow around them, in two titled columns with no
 * head (mock parity web-recheck-03): Value and brand, Look up a name, on grey tiles. Data and the API documentation
 * left this menu on 2026-09-17: they describe the database rather than act on a name, and they keep their footer links.
 */
export default function ToolsMegaMenu({ id, isOpen, onNavigate }: ToolsMegaMenuProps) {
    return (
        <MegaMenuPanel id={id} testId="tools-mega-menu" isOpen={isOpen} width="narrow">
            <MenuGroupColumns groups={LANDING_TOOLS_MENU_GROUPS} density="desktop" onNavigate={onNavigate} testIdPrefix="tools-menu-rows" />
        </MegaMenuPanel>
    );
}
